

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { Loading } from '../../../../../Helper/Loading'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../../../Helper/Context'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { FinancialYearHeaderDDL } from '../../../../../Components/CommonDDL/FinancialYearHeaderDDL'
import { Get_T_ELE_KPI_DumpData_SelectAPI, Post_T_ELE_KPI_DumpData_InsertDataAPI } from '../../../../../Redux/ElectricalSlice/DailyElEDataFetchSlice'
import moment from 'moment'
import { FromReadingDayDDL } from '../../../../../Components/CommonDDL/FromReadingDayDDL'
import { ElEWorkNameDDL } from '../../../../../Components/CommonDDL/ElEWorkNameDDL'
import { MonthDataDDL } from '../../../../../Components/CommonDDL/MonthDataDDL'
import { DummyDataElectrical } from '../../../../../Helper/dummydata'
import { ExportDailyELEDataFetch } from './ExportDailyELEDataFetch'

export const DailyElEdataFetch = () => {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")


    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [IsLoading, setIsLoading] = useState(false)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [OpenCount, setOpenCount] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [FromDay, setFromDay] = useState('')
    const [ToDay, setToDay] = useState('')

    const [tableData, settableData] = useState([])

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const [WorkName, setWorkName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Month, setMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })
    const [ReadingFromDay, setReadingFromDay] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })
    const [ReadingToDay, setReadingToDay] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })
    const [DesignationPopupShow, setDesignationPopupShow] = useState()

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setDesignationPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setrowData(item)
        setDesignationPopupShow(true)
        setapiFlag('Update')
    }

    const handleOnCloseClick = () => {
        setDesignationPopupShow(false)
        handleIsPost()
    }



    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const handleSearch = (IsClear) => {
        const data = {
            T_ELE_KPI_DumpDataID: '0',
            M_FinancialYearID: FinancialYear?.ID,
            M_MonthID: Month?.ID,
            M_ELEC_WorkID: IsClear ? '0' : WorkName?.ID,
            M_WardID: IsClear ? '0' : WardName?.ID,
            StartDay: IsClear ? '0' : ReadingFromDay?.ID,
            EndDay: IsClear ? '0' : ReadingToDay?.ID,
            M_UserID: UserID,
            token: token,
            From: 1,
            To: 99999,
            settableData: settableData
        }
        dispatch(Get_T_ELE_KPI_DumpData_SelectAPI({ data }))
    }

    const { isLoading } = useSelector(state => state.Get_T_ELE_KPI_DumpData_SelectData)


    const handleFetchData = () => {
        const data = {
            M_FinancialYearID: FinancialYear?.ID,
            M_MonthID: Month?.ID,
            StartDay: ReadingFromDay?.ID,
            EndDay: ReadingToDay?.ID,
            M_ELEC_WorkID: WorkName?.ID,
            M_WardID: WardName?.ID,
            ReadingDate: '',
            MiniPillerNo: '',
            TotalOffTimeInHour: '',
            TotalOnTimeInHour: '',
            PillerIsOpen: '',
            PFOcuranceCount: '',
            ReadingTime: '',
            R_C: '',
            Y_C: '',
            B_C: '',
            CalCurrent: '',
            PillerCurrentAmps: '',
            M_UserID: UserID,
            token: token,
            setLoading: setIsLoading,
            handleIsPost: handleIsPostSuccess
        }
        dispatch(Post_T_ELE_KPI_DumpData_InsertDataAPI({ data }))
    }

    const handleClear = () => {
        // setFinancialYear({
        //     ...FinancialYear,
        //     ID: 0,
        //     Label: 'Select...',
        // })
        // setMonth({
        //     ...Month,
        //     ID: 0,
        //     Label: 'Select...',
        // })
        setIsClear(true)
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setWorkName({
            ...WorkName,
            ID: 0,
            Label: 'Select...',
        })
        setReadingFromDay({
            ...ReadingFromDay,
            ID: 0,
            Label: 'Select...',
        })
        setReadingToDay({
            ...ReadingToDay,
            ID: 0,
            Label: 'Select...',
        })
        handleSearch(true)
    }

    const handleIsPostSuccess = () => {
        handleSearch(false)
    }

    const days = Array.from({ length: 31 }, (_, i) =>
        String(i + 1).padStart(2, "0")
    );

    return (
        <>
            {isLoading && <Loading />}
            {IsLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active="pole" listActive="active" />

                    <div id="" className="content1">
                        <div className="data_mob1">
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div>
                                    <h5 className="ps-1 py-1">Daily Electrical Data {`${RoleID == '43' || RoleID == '45' || RoleID == '46' ? 'Search' : 'Fetch'}`}</h5>
                                    {/* <div className="col-12 col-lg-7 float-end">
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white", marginTop: '-2em' }} onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div> */}
                                </div>

                                <div className="row m-0 ">

                                    <div className="col-12 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>

                                        <div className="col-12">


                                            <div className="row py-1 rounded2">

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <label for="" className=""><b>Financial Year</b></label>
                                                    <FinancialYearHeaderDDL
                                                        FinancialYear={FinancialYear}
                                                        setFinancialYear={setFinancialYear}
                                                        // YLable={YLable}
                                                        // HYear={HYear}
                                                        // flag={flag}
                                                        col='10'
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    {/* <label for="" className=""><b>Month </b></label> */}
                                                    <MonthDataDDL
                                                        Month={Month}
                                                        setMonth={setMonth}
                                                        // MLable={MLable}
                                                        // HMonth={HMonth}
                                                        // flag={flag}
                                                        col='10'
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard='0'
                                                        WLable=''
                                                        Type="Electrical"
                                                        APIFlag={(RoleID == 44 || RoleID == 45 || RoleID == 46) ? "UserWiseM_Ward" : "Master"}
                                                        IsPost={IsPost}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <ElEWorkNameDDL
                                                        WorkType='0'
                                                        WorkSubType='0'
                                                        WorkNameType={WorkName}
                                                        setWorkNameType={setWorkName}
                                                        IsPost={IsPost}
                                                        isDisplay={true}
                                                        ApiFlag="Master"
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <label for="" className=""><b>From Reading Day</b></label>
                                                    <FromReadingDayDDL
                                                        ReadingFromDay={ReadingFromDay}
                                                        setReadingFromDay={setReadingFromDay}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <label for="" className=""><b>To Reading Day</b></label>
                                                    <FromReadingDayDDL
                                                        ReadingFromDay={ReadingToDay}
                                                        setReadingFromDay={setReadingToDay}
                                                    />

                                                </div>

                                                <div className="col-12 col-md-4 col-lg-4 mt-4">
                                                    {/* <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" > */}

                                                    <button type="button"
                                                        disabled={
                                                            FinancialYear?.ID == 0 ||
                                                            Month?.ID == 0 ||
                                                            WardName?.ID == 0 ||
                                                            WorkName?.ID == 0 ||
                                                            ReadingFromDay?.ID == 0 ||
                                                            ReadingToDay?.ID == 0
                                                        }
                                                        className="btn btn-primary px-4"
                                                        onClick={() => handleSearch(false)}
                                                    >
                                                        Search</button>

                                                    {
                                                        (RoleID != '43' && RoleID != '45' && RoleID != '46') &&

                                                        <button type="button"
                                                            disabled={
                                                                FinancialYear?.ID == 0 ||
                                                                Month?.ID == 0 ||
                                                                WardName?.ID == 0 ||
                                                                WorkName?.ID == 0 ||
                                                                ReadingFromDay?.ID == 0 ||
                                                                ReadingToDay?.ID == 0
                                                            }
                                                            className="btn btn-outline-primary mx-2 px-4"
                                                            onClick={handleFetchData}
                                                        >
                                                            Fetch Data</button>


                                                    }
                                                    <button type="button"
                                                        className="btn btn-danger ms-1 px-4"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>

                                                {
                                                    (tableData && tableData?.length > 0) &&
                                                    <div className="col-12 col-md-4 col-lg-2 mt-4">
                                                        <ExportDailyELEDataFetch
                                                            ExcelData={tableData}
                                                            name="Daily Electrical Data"
                                                            WardName={WardName?.Label}
                                                            ReadingFromDay={ReadingFromDay?.ID}
                                                            ReadingToDay={ReadingToDay?.ID}
                                                            FinancialYear={FinancialYear?.Label}
                                                            Month={Month?.Label}
                                                        />
                                                    </div>
                                                }
                                            </div>


                                            <div className="row mob_table table-responsive pt-1" style={{ height: '81vh', overflow: 'scroll' }}>

                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered"
                                                    style={{ fontSize: '12px' }}
                                                >
                                                    <thead>
                                                        <tr >
                                                            <th align='center'>Sr.No.</th>
                                                            {/* <th align='center'>Reading Date</th> */}
                                                            <th align='center'>Work Name</th>
                                                            <th align='center'>Mini Piller No.</th>
                                                            <th align='center'>Phase</th>
                                                            <th align='center'>Reading Time</th>
                                                            {days.map(day => (
                                                                <th key={day}>{day}</th>
                                                            ))}
                                                            {/* <th>R_C</th>
                                                            <th>Y_C</th>
                                                            <th>B_C</th> */}
                                                            {/* <th>Avg. Sum</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData?.length > 0 ? tableData.map((pillar, Index) => {
                                                                const totalRows = pillar.phases.reduce(
                                                                    (sum, ph) => sum + ph.records.length,
                                                                    0
                                                                );

                                                                let pillarRendered = false;

                                                                return (
                                                                    <>
                                                                        {pillar.phases.map((phase, phIndex) => {
                                                                            let phaseRendered = false;

                                                                            return phase.records.map((record, rIndex) => (
                                                                                <tr key={`${Index}-${phIndex}-${rIndex}`} style={{ verticalAlign: 'middle' }}>
                                                                                    {/* Left fixed columns */}
                                                                                    {!pillarRendered && (
                                                                                        <>
                                                                                            <td rowSpan={totalRows} style={{ textAlign: "center" }}>{Index + 1}</td>
                                                                                            {/* <td rowSpan={totalRows} style={{ textAlign: "center", whiteSpace: 'nowrap' }}>{pillar.readingDay ? moment(pillar.readingDay).format('DD-MM-YYYY') : "-"}</td> */}
                                                                                            <td rowSpan={totalRows} style={{ textAlign: "center" }}>{pillar?.workName || "-"}</td>
                                                                                            <td rowSpan={totalRows} style={{ textAlign: "center" }}>{pillar?.miniPillarNo}</td>
                                                                                        </>
                                                                                    )}

                                                                                    {/* Phase column */}
                                                                                    {!phaseRendered && (
                                                                                        <td rowSpan={phase.records.length} style={{ textAlign: "center" }}>
                                                                                            {phase.phase}
                                                                                        </td>
                                                                                    )}

                                                                                    {/* Time */}
                                                                                    <td>{record.time}</td>

                                                                                    {/* Day values */}
                                                                                    {days.map(day => (
                                                                                        <td key={day} style={{ textAlign: "center" }}>{record.days[day]}</td>
                                                                                    ))}

                                                                                    {/* Right summary columns */}
                                                                                    {/* {!pillarRendered && (
                                                                                        <>
                                                                                            <td rowSpan={totalRows}>{pillar.summary.benchmarkMax}</td>
                                                                                            <td rowSpan={totalRows}>
                                                                                                {pillar.summary.min}
                                                                                                <hr style={{ margin: '0px' }} />
                                                                                                {pillar.summary.max}
                                                                                            </td>
                                                                                            <td rowSpan={totalRows}>{pillar.summary.defaulterAmp}</td>
                                                                                            <td rowSpan={totalRows}>{pillar.summary.unitPenalty}</td>
                                                                                            <td rowSpan={totalRows}>{pillar.summary.totalPenalty}</td>
                                                                                        </>
                                                                                    )} */}

                                                                                    {pillarRendered = true}
                                                                                    {phaseRendered = true}
                                                                                </tr>
                                                                            ));
                                                                        })}


                                                                        {/* ================= AVGSUM ROW ================= */}
                                                                        {/* < tr >
                                                                            <td colSpan={5}></td>
                                                                            <td colSpan={0}><b>AvgSum</b></td>

                                                                            {days.map(day => (
                                                                                <td key={day}><b>{pillar?.avgSum?.[day]}</b></td>
                                                                            ))}



                                                                            <td colSpan={0}></td>
                                                                            <td colSpan={0}></td>
                                                                            <td colSpan={0}></td>
                                                                            <td colSpan={0}></td>
                                                                            <td colSpan={0}></td>

                                                                        </tr> */}

                                                                        {/* ================= DEFAULTER ROW ================= */}
                                                                        {/* <tr>
                                                                            <td colSpan={5}></td>
                                                                            <td colSpan={0}><b>Defaulter</b></td>

                                                                            {days.map(day => (
                                                                                <td key={day}><b>{pillar?.defaulterDays?.[day]}</b></td>
                                                                            ))}

                                                                            {
                                                                                pillar?.defaulterSummary && pillar?.defaulterSummary?.length > 0 && pillar?.defaulterSummary.map(i => {
                                                                                    return (
                                                                                        <>
                                                                                            <td colSpan={0}><b>{i?.benchmarkMax}</b></td>
                                                                                            <td colSpan={0}><b>{i?.minmax}</b></td>
                                                                                            <td colSpan={0}><b>{i?.defaulterAmp}</b></td>
                                                                                            <td colSpan={0}><b>{i?.unitPenalty}</b></td>
                                                                                            <td colSpan={0}><b>{i?.totalPenalty}</b></td>
                                                                                        </>
                                                                                    )
                                                                                })
                                                                            }


                                                                        </tr> */}
                                                                    </>
                                                                );
                                                            })
                                                                :
                                                                <tr>
                                                                    <td colSpan={42}>No Data Found...</td>
                                                                </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            } */}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {/* {
                    DesignationPopupShow ?
                        <WardWiseTokenModal
                            open={DesignationPopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                } */}


            </div>

        </>
    )
}